// extracted by mini-css-extract-plugin
module.exports = {"contentCentered":"FullPageLayout_contentCentered__3W_tH","content":"FullPageLayout_content__1w98E"};